// const authServer = 'dance-dj.auth.us-east-1.amazoncognito.com';
const authServer = 'auth.dance-dj.com';
export var config = { 
  axios:require('axios'),
  clientID:'7nfrf6m03hivf2ku12hm13bho7',
  loginURI:`https://${authServer}/oauth2/authorize`,
  authScope:['email', 'https://api.dance-dj.com/dance-dj-api', 'openid', 'profile'],
  loginRedirect:'https://www.dance-dj.com/app/login',
  authURI:`https://${authServer}/oauth2/token`,
  tokenRedirect:'https://www.dance-dj.com/app',
  apiURLBase:'https://api.dance-dj.com',
  uploadBucket:'dance-dj-import-upload'
}
config.fullLoginURI = `${config.loginURI}?client_id=${config.clientID}` + 
  "&response_type=code" + 
  "&scope=email+https%3A%2F%2Fapi.dance-dj.com%2Fdance-dj-api+openid+profile" + 
  "&redirect_uri=https%3A%2F%2Fapi.dance-dj.com";
config.cognitoLogout = 
  `https://${authServer}/logout?client_id=${config.clientID}` +
  "&logout_uri=" + encodeURIComponent('https://api.dance-dj.com/?logout=true');
config.logoutURI = 
  `${config.apiURLBase}/?logout=true`;
